import { matchRoutes } from "react-router";

import { getEnvConfig } from "@app/utils";
import {
  createReactRouterV6DataOptions,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from "@grafana/faro-react";

export const initializeTelemtry = () => {
  const env = getEnvConfig();

  if (!env.OTEL_COLLECTOR_URL) {
    console.warn("unable to initialize telemtry");
    return;
  }

  const faro = initializeFaro({
    url: env.OTEL_COLLECTOR_URL,
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new ReactIntegration({
        router: createReactRouterV6DataOptions({ matchRoutes }),
      }),
    ],
    app: {
      name: `honeycomb`,
      environment: env.ENV,
    },
    trackResources: true,
    batching: {
      itemLimit: 100,
    },
  });

  faro.api.pushLog(["Faro was initialized"]);
};
